import { ExtendsMainComponent } from '../extends/extends-main.component';

import { SelectMultiResourceComponent } from './select-multi-resource.component';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

import { TokenManager } from '../../service/web-api.service';
import { WebApiService } from '../../service/web-api.service';
import { SelectMultiResourceService } from '../../service/select-multi-resource.service';

import { environment } from '../../../environments/environment';

declare let gtag: any; // グローバル変数gtagを解決

export class SelectMultiResourceMainComponent extends ExtendsMainComponent {
  private selectMultiResourceComponent: SelectMultiResourceComponent;
  private selectMultiResourceService: SelectMultiResourceService;
  private waitModal: WaitModalComponent;
  private confirmModal: ConfirmModalComponent;

  // V2の判定
  public isV2: boolean;

  // 画面項目定義
  public clientName: string;
  public selectedParentResource: any;
  public dispZ0001: string;
  public messages: any;

  // 子リソース表示区分コード（単体：'1' 複数：'2'）
  public accountSelectCode: string;

  // 表示区分が単体の場合にデフォルトで選択されている子リソース
  public selectedResource: any;

  // 認可済み子リソース選択状態
  public childResourceSelectMode: string;

  // 認可済み子リソース選択状態
  public errorCode: string;

  // 認可済み子リソース選択状態
  public errorMessage: string;

  init(_selectMultiResourceComponent: SelectMultiResourceComponent, _selectMultiResourceService: SelectMultiResourceService,
    _waitModal: WaitModalComponent, _confirmModal: ConfirmModalComponent) {

    this.config();

    this.selectMultiResourceComponent = _selectMultiResourceComponent;
    this.selectMultiResourceService = _selectMultiResourceService;
    this.waitModal = _waitModal;
    this.confirmModal = _confirmModal;

    this.clientName = this.selectMultiResourceComponent.clientName;
    this.selectedParentResource = this.selectMultiResourceComponent.selectedParentResource;
    this.dispZ0001 = this.selectMultiResourceComponent.dispZ0001;
    this.accountSelectCode = this.selectMultiResourceComponent.accountSelectCode;
    this.childResourceSelectMode = this.selectMultiResourceComponent.childResourceSelectMode;
    this.messages = [];

    this.errorCode = this.selectMultiResourceComponent.errorCode;
    this.errorMessage = this.selectMultiResourceComponent.errorMessage;

    if (this.accountSelectCode === '1') {
      for (const resource of this.selectedParentResource.childResourceList) {
        if (resource.checked) {
          this.selectedResource = resource;
          break;
        }
      }
    }

    if (this.childResourceSelectMode === 'locked') {
      for (const resource of this.selectedParentResource.childResourceList) {
        resource.disabled = (this.accountSelectCode === '1') ? true : resource.checked;
      }
    }

    if (this.childResourceSelectMode === 'none') {
      this.resetChecked();
    }
  }

  /**
   * イベント：次へ
   *
   */
  next() {
    // 引継ぎ項目
    this.selectMultiResourceComponent.pageNo++;
    this.selectMultiResourceComponent.selectedParentResource = this.selectedParentResource;

    // 画面切り替え
    this.selectMultiResourceComponent.directInjection();
  }

  /**
   * イベント：戻る
   * @param needsClearChecked チェック項目をリセットするか
   */
  back(needsResetChecked) {
    // 引継ぎ項目
    this.selectMultiResourceComponent.pageNo--;

    if (needsResetChecked) {
      this.resetChecked();
    }

    // 画面切り替え
    this.selectMultiResourceComponent.directInjection();
  }

  /**
   * チェック項目をリセット
   */
  private resetChecked() {
    for (const resource of this.selectedParentResource.childResourceList) {
      resource.checked = false;
    }
    this.selectedResource = undefined;
    this.selectMultiResourceComponent.selectedParentResource = this.selectedParentResource;
  }

  /**
   * リソース選択処理
   */
  confirmResourceList() {

    let selectResourceId = '';
    let selectResourceName = '';
    let selectParentResourceId = '';

    selectParentResourceId = this.selectedParentResource.resourceId;
    if (this.accountSelectCode === '2') {
      for (const resource of this.selectedParentResource.childResourceList) {
        if (resource.checked) {
          if (selectResourceId !== '') {
            selectResourceId += ',';
          }
          selectResourceId += resource.resourceId;
          selectResourceName += '【' + resource.resourceDisplayName + '】<br>';
        }
      }
    } else {
      if (this.selectedResource != null) {
        selectResourceId = this.selectedResource.resourceId;
        selectResourceName = '【' + this.selectedResource.resourceDisplayName + '】<br>';
      }
    }

    if (selectResourceId === '') {
      this.selectMultiResource(selectParentResourceId, selectResourceId);
      return;
    }

    this.messages = [];
    const param = { 'value': selectResourceName };
    let message = '';
    this.selectMultiResourceComponent.translateService.get('SELECT_CONFIRMATION', param).subscribe((res: string) => {
      message = res;
    });
    this.confirmModal.showConfirmModal(message, 'OK').subscribe(
      result => {
        if (result) {
          this.selectMultiResource(selectParentResourceId, selectResourceId);
        }
      });
  }

  /**
   * リソース選択処理内のメソッド
   */
  selectMultiResource(parentResourceId, resourceId) {
    this.waitModal.showModal();
    this.selectMultiResourceService.execSelectResource(parentResourceId, resourceId).subscribe(result => {
      // 正常時
      if (result == null) {
        this.messages = [];
        this.locationAssign('/oauth/v2/authorization/verify?' + TokenManager.getToken());

      } else {
        this.messages = result;
        // 再表示
        this.selectMultiResourceService.execResourceInfoList().subscribe(
          resultData => {
            this.waitModal.hideModal();
            const listResult = resultData.resourceInfoList[0];
            const accountSelectCodeResult = resultData.accountSelectCode;
            const childResourceSelectMode = resultData.childResourceSelectMode;

            if (this.selectedParentResource.childResourceList.length !== listResult.childResourceList.length) {

              // 引継ぎ項目
              this.selectMultiResourceComponent.isError = !resultData.result;
              this.selectMultiResourceComponent.pageNo = 1;
              this.selectMultiResourceComponent.selectedParentResource = listResult;
              this.selectMultiResourceComponent.accountSelectCode = accountSelectCodeResult;
              this.selectMultiResourceComponent.childResourceSelectMode = childResourceSelectMode;

              // 画面切り替え
              this.selectMultiResourceComponent.directInjection();

            } else {
              this.scrollError();
            }
          },
          error => {
            this.selectMultiResourceComponent.router.navigate(['/error', 500]);
          }
        );
      }
    });
  }

  /**
   * キャンセルボタン押下処理
   */
  cancel() {
    this.locationAssign('/oauth/v2/authorization/cancel?' + TokenManager.getToken());
  }

  /**
   * イベント：代表リソース選択画面遷移
   */
  toSelectResource() {
    this.selectMultiResourceComponent.router.navigate(['select-resource']);
  }

}
